import { UserOutlined } from '@ant-design/icons';
import { useAppDispatch } from '@core/redux/hooks';
import { tryLogout } from '@features/auth/store/auth.thunk';
import { Avatar, Layout, Menu, Popover } from 'antd';
import { FC, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Logo } from '../../../app/framework/atoms/Icons/Logo';
import { ModalChangePassword } from './ModalChangePassword';
export const AppHeader: FC = () => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const dispatch = useAppDispatch();
  const onLogout = useCallback(() => dispatch(tryLogout()), []);
  const content = (
    <div>
      <MenuSelect onClick={() => setIsModalVisible(true)}>
        Alterar senha
      </MenuSelect>
      <MenuSelect onClick={onLogout} style={{ color: 'red', margin: 0 }}>
        Sair
      </MenuSelect>
    </div>
  );
  return (
    <>
      <Header style={{ backgroundColor: '#141414' }}>
        <RightMenu
          mode='horizontal'
          selectedKeys={[]}
          items={[
            {
              key: 'logo',
              icon: (
                <BrandLogo
                  style={{
                    marginBottom: 0,
                    flexShrink: 0,
                  }}
                  width={138}
                  height={15}
                />
              ),
              onClick: () => {
                navigate('/home');
              },
              style: {
                marginLeft: '80px',
              },
            },
            {
              key: 'logout',
              icon: (
                <Popover
                  content={content}
                  trigger='click'
                  placement='bottomLeft'
                >
                  <Avatar icon={<UserOutlined />} />
                </Popover>
              ),
              style: {
                marginLeft: 'auto',
                marginRight: '22px',
              },
            },
          ]}
        />
      </Header>
      <ModalChangePassword
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      />
    </>
  );
};

const RightMenu = styled(Menu)`
  height: 64px;
  & .ant-menu-item {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`;

const Header = styled(Layout.Header)`
  background-color: #1f1f1f;
  position: relative;
  padding: 0px;
  z-index: 2;
`;
const BrandLogo = styled(Logo)`
  margin-bottom: 0;
`;

const MenuSelect = styled.p`
  cursor: pointer;
`;
